import React, { useEffect, useState } from "react";
import outletService from "../../../services/http/stores/outlet.service";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import { useTranslation } from "react-i18next";
import useRoleAndPerm from "../../../utils/permissionFunction";
import Select from "react-select";
import { useSelector } from "react-redux";
import OutletDetailsLogs from "../outlets/Details/outlet-details-logs";
const OutletLogsList = () => {
  const { hasPermission } = useRoleAndPerm();
  const { t } = useTranslation();
  const [purchaseIsLoading, setPurchaseIsLoading] = useState(false);
  const [outlet, setOutlet] = useState([]);
  const [selectedOutletId, setSelectedOutletId] = useState(null);

  useEffect(() => {
    fetchOutlet();
  }, []);
  async function fetchOutlet() {
    try {
      const outlet = await outletService.outletList();
      setOutlet(outlet?.data?.data?.data);
      if (outlet?.data?.data?.data && outlet?.data?.data?.data.length > 0) {
        setSelectedOutletId({
          ...outlet?.data?.data?.data[0],
          value: outlet?.data?.data?.data[0].id,
          label: outlet?.data?.data?.data[0].name,
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setPurchaseIsLoading(false);
    }
  }

  const breadcrumbItems = [
    { label: "", link: "/", icon: "feather-home" },
    { label: t("tableColumnName.shopLogs"), active: true },
  ];

  const outletOptions = outlet?.map((outlet) => ({
    ...outlet,
    value: outlet.id,
    label: outlet.name,
  }));

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex flex-column">
              <div className="page-title">
                <h4>{t("tableColumnName.shopLogs")}</h4>
              </div>
              <UnlimitBreadcrumb items={breadcrumbItems} />
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              {/* /Filter */}
              <div
                className={`card visible mt-md-4 mb-md-3`}
                id="filter_inputs"
                style={{ display: "block" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-5 col-sm-5 col-12 ">
                      <div className="unlimit-uikit-select">
                        <label className="mb-2">
                          {t("tableColumnName.shop")}
                        </label>
                        <Select
                          options={outletOptions}
                          className="select custom-select"
                          placeholder={t("inputField.placeholder.chooseShop")}
                          value={selectedOutletId}
                          formatOptionLabel={({ label, image }) => (
                            <div className="d-flex">
                              {image && (
                                <img
                                  src={image}
                                  alt=""
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 10,
                                    objectFit: "contain",
                                  }}
                                />
                              )}
                              <span style={{ marginLeft: 10 }}>{label}</span>
                            </div>
                          )}
                          onChange={(selectedOption) =>
                            setSelectedOutletId(selectedOption)
                          }
                          isLoading={purchaseIsLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
              <OutletDetailsLogs type="OUTLET" id={selectedOutletId?.value} />
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};

export default OutletLogsList;
